export default [
    {
        path: "/",
        redirect: "/login"
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("../views/Screen/Login.vue")
    },
    {
        path: "/home",
        name: "Home",
        component: () => import("../views/Screen/Home.vue")
    },
    {
        path: "/linea",
        name: "LineA",
        component: () => import("../views/Screen/LineA.vue")
    },
    {
        path: "/lineb",
        name: "LineB",
        component: () => import("../views/Screen/LineB.vue")
    },
    {
        path: "/linec",
        name: "LineC",
        component: () => import("../views/Screen/LineC.vue")
    },
    {
        path: "/lined",
        name: "LineD",
        component: () => import("../views/Screen/LineD.vue")
    },
    {
        path: "/linee",
        name: "LineE",
        component: () => import("../views/Screen/LineE.vue")
    },
    {
        path: "/linef",
        name: "LineF",
        component: () => import("../views/Screen/LineF.vue")
    },
    {
        path: "/lineg",
        name: "LineG",
        component: () => import("../views/Screen/LineG.vue")
    },
    {
        path: "/lineh",
        name: "LineH",
        component: () => import("../views/Screen/LineH.vue")
    }
];
